import { useTranslation } from "react-i18next";
import { LANDING } from "@/constants/testIds";

const HERO_IMG = "/hero-tesori-europa.jpg";

export default function Hero() {
  const { t } = useTranslation();
  return (
    <section
      id="home"
      data-testid={LANDING.hero}
      className="relative min-h-[100vh] w-full overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Tesori d'Europa — partecipa alla bellezza che custodiamo"
          className="w-full h-full object-cover"
        />
        {/* Very soft brightening wash so the navy headline reads cleanly */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/30 via-white/10 to-white/30" />
      </div>

      {/* Centered headline */}
      <div className="relative z-10 flex items-center justify-center min-h-[100vh] px-6 md:px-10">
        <div className="max-w-5xl text-center">
          <h1
            data-testid={LANDING.heroHeadline}
            className="font-display reveal text-[#1a365d] text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[1.02] tracking-tight font-medium"
            style={{ textShadow: "0 2px 24px rgba(255,255,255,0.55)" }}
          >
            {t("hero.title1")}
            <br />
            <span className="italic font-normal text-[#1a365d]/90">
              {t("hero.title2")}
            </span>
          </h1>
          <span
            aria-hidden
            className="reveal delay-1 mt-10 inline-block h-[2px] w-16 bg-[#d4af37]"
          />
        </div>
      </div>
    </section>
  );
}
